import React from "react";

import { ScrollSyncProvider } from "./ScrollSyncContext";

interface Props {
  enabled?: boolean;
  children?: React.ReactNode;
}

const ScrollSync = React.memo((props: Props) => {
  const { enabled, children } = props;

  return <ScrollSyncProvider enabled={enabled}>{children}</ScrollSyncProvider>;
});

export default ScrollSync;
